// Design tokens — Consumo (página + detalhes de conversas).
// Linguagem: neutros zinc sobre #f4f4f7; violeta (#7C3AED) só como acento.

export const CONSUMO_COMPONENT_DESIGN = {
  page: {
    // Header sticky full-bleed — padrão em
    // configuracoes/CONFIG_PAGE_HEADER.md (mesma estrutura de respostas-rapidas
    // / apis / consumo/conversas).
    root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
    container: 'w-full px-4 md:px-6 lg:px-8',
    stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
    pageBody: 'pt-6 pb-[60px]',
    topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
    topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
    topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
    header: {
      container:
        'flex flex-col md:flex-row justify-between items-start md:items-center gap-4',
      title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
      subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
    },
  },
  cards: {
    container: 'grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-4',
    card: 'bg-white p-4 rounded-xl border border-[#e7e7ec] cursor-pointer hover:border-violet-300 hover:shadow-sm transition-all group',
    title: 'text-sm font-semibold text-[#7C3AED]',
    value: 'text-sm font-bold',
    label: 'text-xs text-[#71717a]',
  },
  details: {
    root: 'flex flex-col min-h-full w-full bg-[#f4f4f7] text-[#18181b] animate-in fade-in slide-in-from-bottom-4 duration-500',
    fontStack: "'Plus Jakarta Sans', Manrope, ui-sans-serif, system-ui, sans-serif",
    stickyHeader: 'sticky top-0 z-30 bg-white border-b border-[#e7e7ec]',
    container: 'w-full px-4 md:px-6 lg:px-8',
    topbar: 'flex flex-col md:flex-row md:items-start gap-4 pt-[18px] pb-[18px]',
    topbarIdentity: 'flex items-start gap-3.5 min-w-0 flex-1',
    backButton:
      'flex items-center justify-center flex-shrink-0 w-[34px] h-[34px] mt-[3px] rounded-lg bg-transparent text-[#71717a] transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
    iconTile:
      'flex items-center justify-center flex-shrink-0 w-[42px] h-[42px] rounded-[10px] bg-[#ede9fe] text-[#6d28d9]',
    title: 'text-[20px] font-bold tracking-[-0.02em] leading-tight text-[#18181b]',
    subtitle: 'mt-[5px] text-[13px] text-[#71717a] leading-[1.5]',
    topbarActions: 'flex items-center gap-2.5 flex-shrink-0 flex-wrap md:pt-[5px]',
    pageBody: 'pb-[80px] pt-5 space-y-4',
    stats: 'grid grid-cols-2 md:grid-cols-4 gap-3',
    statCard:
      'bg-white rounded-xl border border-[#e7e7ec] px-4 py-3.5 flex items-center gap-3 min-w-0',
    statIcon:
      'w-10 h-10 rounded-xl flex items-center justify-center bg-violet-50 text-[#7C3AED] flex-shrink-0',
    statValue: 'text-xl font-bold text-[#18181b] tabular-nums leading-none',
    statLabel: 'text-xs text-[#71717a] mt-1',
    contentGrid: 'grid grid-cols-1 xl:grid-cols-12 gap-4 items-start',
    chartsCol: 'xl:col-span-4 flex flex-col gap-3',
    tableCol: 'xl:col-span-8 min-w-0',
    chartCard: 'bg-white rounded-xl border border-[#e7e7ec] p-4',
    chartTitle: 'text-[13px] font-semibold text-[#18181b] mb-3',
    chartBox: 'h-48 w-full',
    rateGrid: 'grid grid-cols-2 gap-2 mt-2',
    rateItem: 'rounded-lg border px-2.5 py-2 text-center',
    rateValue: 'text-base font-bold tabular-nums leading-none',
    rateLabel: 'text-[10px] font-medium mt-1',
    panel: 'bg-white rounded-xl border border-[#e7e7ec] overflow-hidden flex flex-col min-h-[480px]',
    filters:
      'flex flex-wrap items-end gap-2.5 px-4 py-3 border-b border-[#e7e7ec] bg-white',
    filterLabel:
      'text-[10px] font-semibold text-[#a1a1aa] uppercase tracking-wider mb-1 block',
    filterSelect:
      'h-9 min-w-[130px] text-xs rounded-lg border border-[#d4d4d8] bg-white shadow-none hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus:ring-2 focus:ring-[#c4b5fd]',
    filterInput:
      'h-9 min-w-[120px] text-xs rounded-lg border border-[#d4d4d8] bg-white shadow-none placeholder:text-[#a1a1aa] hover:border-[#b8b8c0] focus:border-[#8b5cf6] focus-visible:ring-2 focus-visible:ring-[#c4b5fd]',
    clearBtn:
      'h-9 px-3 text-xs font-semibold text-[#52525b] rounded-lg border border-[#e7e7ec] bg-white hover:bg-[#f4f4f7] disabled:opacity-40',
    tableScroll: 'flex-1 overflow-auto',
    table: 'w-full min-w-[720px] text-sm',
    thead: 'sticky top-0 z-10 bg-[#fafafb] border-b border-[#e7e7ec]',
    th: 'px-3 py-2.5 text-left text-[11px] font-semibold uppercase tracking-[0.04em] text-[#a1a1aa] whitespace-nowrap',
    row: 'border-b border-[#f0f0f3] last:border-0 hover:bg-violet-50/40 transition-colors bg-white',
    td: 'px-3 py-2.5 text-[13px] text-[#18181b] align-middle whitespace-nowrap',
    empty: 'flex flex-col items-center justify-center gap-2 py-20 px-6 text-center',
    emptyIcon:
      'w-14 h-14 rounded-2xl bg-[#f4f4f7] flex items-center justify-center text-[#a1a1aa] mb-1',
    emptyTitle: 'text-sm font-semibold text-[#18181b]',
    emptySub: 'text-xs text-[#71717a] max-w-sm',
    footerMeta: 'px-4 py-3 border-t border-[#e7e7ec] text-xs text-[#71717a] bg-white',
    badge:
      'inline-flex items-center gap-1.5 px-2 py-0.5 rounded-full text-[11px] font-medium border',
    badgeDot: 'w-1.5 h-1.5 rounded-full',
    ghostButton:
      'inline-flex items-center justify-center gap-2 px-4 py-[9px] rounded-lg border border-[#e7e7ec] bg-white text-[13px] font-semibold text-[#52525b] whitespace-nowrap transition-colors hover:bg-[#f4f4f7] hover:text-[#18181b]',
  },
};
